module.exports = __webpack_public_path__ + "static/media/gucci_fw17-ad-campaign5.b53d34e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/designers/gucci_fw17-ad-campaign5.jpg
// module id = 154
// module chunks = 0